import React from 'react';
import PropTypes from 'prop-types';
import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';

import './TwoValueBar.css';

const TwoValueBar = ({ sectionTitle, label1, value1, label2, value2, image, colors, children }) => {
  return (
    <div className="section-graph">
      <ViewerPrimaryColorUserStyle domStyle="color">
        <h4 className="section-title">{sectionTitle}</h4>
      </ViewerPrimaryColorUserStyle>

      <div className="two-value-label-container">
        <div className="two-value-label-left">
          <h3>{label1}</h3>
        </div>

        <div className="two-value-label-right">
          <h3>{label2}</h3>
        </div>
      </div>

      <div className="two-value-bar-container">
        <div className="two-value-bar-left" style={{ backgroundColor: colors[0] }}>
          <h3>{value1}</h3>
        </div>

        <div className="two-value-bar-right" style={{ backgroundColor: colors[4] }}>
          <h3>{value2}</h3>
        </div>

        <div className="two-value-bar-middle" style={{ borderColor: colors[0] }}>
          <img src={image} alt="" />
        </div>
      </div>

      {children}
    </div>
  );
};

TwoValueBar.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
  colors: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string]))
  .isRequired,
  label1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  image: PropTypes.string.isRequired,
  children: PropTypes.element,
};

export default TwoValueBar;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaOverview/TwoValueBar/TwoValueBar.js